import { V2Router } from '../router/v2.router';
import { Logger } from '../lib/logger';
import { LoggerNames } from '../lib/constants';

export type UserSession =
  | {
      login: string;
      eventId: string;
      userId: string;
      createdAt: string;
      expiresAt: string;
      status: 'Active';
      clientId: string;
    }
  | { status: 'Inactive' };

/**
 * @deprecated - Will not work without 3rd party cookies.
 */
export class Session {
  private readonly logger: Logger;
  private readonly router: V2Router;

  constructor(router: V2Router) {
    this.router = router;
    // Keeping this logger scoped to Authn for simplicity since they are both deprecated
    this.logger = Logger.createLogger(LoggerNames.AUTHN);
  }

  /**
   * @deprecated - Will not work without 3rd party cookies.
   */
  async exists(): Promise<boolean> {
    const session = await this.get();
    return session.status === 'Active';
  }

  /**
   * @deprecated - Will not work without 3rd party cookies.
   */
  async get(): Promise<UserSession> {
    try {
      return await this.router.me();
    } catch (e) {
      return { status: 'Inactive' };
    }
  }

  /**
   * @deprecated - Will not work without 3rd party cookies.
   */
  async closeSession(): Promise<void> {
    try {
      await this.router.deleteMe();
    } catch (e) {
      this.logger.error('Error closing session', e);
    }
  }
}
